import { Button } from '@portals/core/src/components/Button/Button';
import { ExternalLink } from '@portals/icons';
import { getFixedT } from 'i18next';
import React from 'react';

import { CockpitRedirectDialog } from '../../../components';
import { useCockpitRedirectDialog } from '../../../hooks';
import { theme } from '../../../themes/main';
import { SxStyles } from '../../../types';

const t = getFixedT(null, 'core-immobilien', 'watchlist.cockpit');

const styles: SxStyles = {
  icon: {
    width: { xs: theme.spacing(5), lg: theme.spacing(6) },
    height: { xs: theme.spacing(5), lg: theme.spacing(6) },
  },
  button: {
    mt: { xs: 4, sm: 'auto' },
  },
};

export const CockpitButton: React.FC = () => {
  const { onSave, onRedirect, onClose, isOpen, isDisabled } = useCockpitRedirectDialog();

  return (
    <>
      {isOpen && <CockpitRedirectDialog onClose={onClose} onRedirect={onRedirect} />}
      <Button
        variant="inverted"
        endIcon={<ExternalLink sx={styles.icon} />}
        sx={styles.button}
        onClick={onSave}
        disabled={isDisabled}
      >
        {t('saveButton')}
      </Button>
    </>
  );
};

CockpitButton.displayName = 'CockpitButton';
